import {baseApi} from '../../rest'
import {TaskSettings} from './state'

interface TaskSettingsReponse {
  [siteName: string]: {
    [taskGroupName: string]: TaskSettingsRow[]
  }
}

interface TaskSettingsRow {
  id: string
  name: string
  icon: string
  sites: string[]
}

export const settingsApi = {
  ...baseApi,
  async getTaskSettings(): Promise<TaskSettings> {
    const request = await this.doRequest<TaskSettingsReponse>({
      path: '/v1/settings/tasks'
    })
    const response = await request.get()
    return (response as unknown) as TaskSettings
  },
  async exportTaskSettings(filters: any): Promise<{body: string; isBase64Encoded: boolean}> {
    const request = await this.doRequest<{body: string; isBase64Encoded: boolean}>({
      path: '/v1/settings/tasks/export',
      payload: filters
    })
    const response = await request.post()
    return (response as unknown) as {body: string; isBase64Encoded: boolean}
  }
}
